import { render, staticRenderFns } from "./File_modification_important.vue?vue&type=template&id=3e645ff7&style=height%3A%20100%25%3B"
import script from "./File_modification_important.vue?vue&type=script&lang=js"
export * from "./File_modification_important.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports